

export const checkNotificationLink = (not) => {
    const data = JSON.parse(not.dataJson);
    if (data) {
        const { event, certId, deepLink } = data;
        const url = new URL(deepLink, "http://learning-go-edu.com");
        const path = url?.pathname?.replace("/deeplink/", "");
        const urlParams = url ? Object.fromEntries(url.searchParams.entries()) : null;
        if (path) {
            switch (path) {
                case "certificate": return `/certifications/${urlParams.certId}`;
                case "course": return urlParams.certId ? `/certifications/${urlParams.certId}` : `/certifications`;
                case "unit":
                case "topic":
                    let rdLink = `/user/course/details?courseId=${urlParams.courseId}&`;
                    if (urlParams.unitId) rdLink += `unitId=${urlParams.unitId}&`;
                    if (urlParams.topicId) rdLink += `topicId=${urlParams.topicId}&`;
                    rdLink = rdLink.slice(0, -1);
                    return rdLink;
                case "calendar": return `/user/dashboard`;
                case "user-subscr": return `/user/course/details?courseId=${urlParams.courseId}`;
            }
        }

        switch (event) {
            case "NEW_CALENDAR_ADDED": return "/user/dashboard";
            case "NEW_CERT_ADDED": return `/certifications/${certId}/packages`;
            case "NEW_COURSE_ADDED": return certId ? `/certifications/${certId}` : '/certifications';
            case "NEW_TOPIC_ADDED": return "/user/dashboard";
            case "NEW_UNIT_ADDED": return "/user/dashboard";
            case "NEW_TOPIC_VIDEO_ADDED": return "/user/dashboard";
            case "USER_SUBSCRIBE_ABOUT_END": return "/user/subscriptions";
            case "USER_SUBSCRIBE": return "/user/subscriptions";
            case "USER_SUBSCRIBE_PAY": return "/user/subscriptions";
            default: return "#";
        }
    }

    return "#";
};